import React, { Fragment } from 'react';
import ConfirmBulkDelete from './ConfirmBulkDelete';

const ConfirmBulkActions = props => {
    return (
        <Fragment>
        <ConfirmBulkDelete label="Reset Views" {...props} />
        </Fragment>
    );
}

export default ConfirmBulkActions;